import { Route } from "react-router-dom";
import RequireAuth from "../Auth/RequireAuth";
import SecuredRoute from "../components/common/VFX-UI/SecuredRoute/SecuredRoute";
import {
  permissions,
  roles,
  getOrganizationId,
} from "../utility/helpers/claimHelper";
import OrganizationDashboard from "../components/Dashboard/OrganizationDashboard";
import OrganizationsContainer from "../components/Organization/OrganizationsContainer";
import OrganizationContainer from "../components/Organization/OrganizationContainer";
import UsersContainer from "../components/Users/UsersContainer";
import Dashboard from "../components/Dashboard/PowerBi/Dashboard";

export default (
  <>
    <Route
      path="/organization-page"
      element={
        <RequireAuth>
          <OrganizationDashboard />
        </RequireAuth>
      }
    />
    <Route
      path="/organization"
      element={
        <RequireAuth>
          <SecuredRoute
            requiredPermission={[
              permissions.MANAGE_ORGANIZATION,
              roles.SYSTEM_ADMIN,
            ]}
          >
            <OrganizationsContainer />
          </SecuredRoute>
        </RequireAuth>
      }
    />
    <Route
      path="/organization/:id"
      element={
        <RequireAuth>
          <SecuredRoute
            requiredPermission={[
              permissions.MANAGE_ORGANIZATION,
              roles.SYSTEM_ADMIN,
              permissions.CORPORATE_USER,
            ]}
          >
            <OrganizationContainer />
          </SecuredRoute>
        </RequireAuth>
      }
    />
    <Route
      path="/organization-page/users"
      element={
        <RequireAuth>
          <SecuredRoute requiredPermission={permissions.CORPORATE_USER}>
            <UsersContainer organizationId={getOrganizationId()} />
          </SecuredRoute>
        </RequireAuth>
      }
    />
    <Route
      path="/leadership-dashboard/:id"
      element={
        <RequireAuth>
          <Dashboard />
        </RequireAuth>
      }
    />
    <Route
      path="/organization-dashboard/:id"
      element={
        <RequireAuth>
          <Dashboard />
        </RequireAuth>
      }
    />
  </>
);
